import { render, staticRenderFns } from "./renewListModal.vue?vue&type=template&id=5924db74&scoped=true&"
import script from "./renewListModal.vue?vue&type=script&lang=js&"
export * from "./renewListModal.vue?vue&type=script&lang=js&"
import style0 from "./renewListModal.vue?vue&type=style&index=0&id=5924db74&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5924db74",
  null
  
)

export default component.exports